export function UnlockFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.445 5.332a1 1 0 001.397-.29 2.842 2.842 0 01.508-.492c.37-.278.915-.55 1.65-.55a2 2 0 012 2v2H7a3 3 0 00-3 3v8a3 3 0 003 3h10a3 3 0 003-3v-8a3 3 0 00-3-3h-1V6a4 4 0 00-4-4c-1.265 0-2.22.478-2.85.95a4.841 4.841 0 00-.899.88l-.054.074-.018.025-.006.01-.003.003-.001.002s-.001.001.831.556l-.832-.555a1 1 0 00.277 1.387zm1.382-.27a.685.685 0 00.005-.007l-.002.002-.001.003-.002.003c-.001 0-.001 0 0 0zM14 14a2 2 0 01-1 1.732V17a1 1 0 11-2 0v-1.268A2 2 0 0112 12a2 2 0 012 2z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
